module.exports = __webpack_public_path__ + "static/media/crdpaganj.7a0497e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/crdpaganj.png
// module id = 174
// module chunks = 0